import Header from "./Headers";
import Const from "../util/Constants"
import Config from "../config/config";

class FloorRiseAPI{
 static save = (floorRise, success, failure, logout) => {
    fetch(Config.app.link + 'api/floor-rise/add-edit',new Header('POST', floorRise))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static getList = (projectId, towerId, success, failure, logout) => {
    fetch(
      Config.app.link + `api/floor-rise/list?project_id=${projectId}&tower_id=${towerId}`,new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  };

   static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/floor-rise/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}

export default FloorRiseAPI;